<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_v"></a><a id="ch00_fm04_title"></a><strong>A PLACE TO STAND</strong></h1>
<p class="textcenter1"><strong><em>The Making of a Poet</em></strong></p>
<p class="publisher"><img alt="images" src="images/common.jpg"/></p>
<p class="textcenter"><strong>Jimmy Santiago Baca</strong></p>
<p class="publisher1"><img alt="images" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_title.vue?4955146c